export default __webpack_public_path__ + "static/media/0.6d85b69e.png";